"use strict";

var CONTENT_TYPE = "Content-Type";
var JSON_CONTENT_TYPE = "application/json";
var _ = require("../../../../utils/mindash");

module.exports = {
  id: "stringifyJSON",
  before: function before(req) {
    var contentType = req.headers[CONTENT_TYPE] || JSON_CONTENT_TYPE;

    if (typeof FormData !== "undefined" && req.body instanceof FormData) {
      return;
    }

    if (contentType === JSON_CONTENT_TYPE && _.isObject(req.body)) {
      req.body = JSON.stringify(req.body);
      req.headers[CONTENT_TYPE] = JSON_CONTENT_TYPE;
    }
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/stateSource/inbuilt/http/hooks/stringifyJSON.js
 ** module id = 490
 ** module chunks = 0
 **/